import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import Card from 'components/Card';

const ErrorMessage = ({ message }) => {
  const { t } = useTranslation();
  // Check if the message includes a set of words
  const messageMatchesCondition = condition =>
    condition.every(el => message.includes(el));
  // Get the translated error message if available
  const getErrorMessage = () => {
    if (messageMatchesCondition(['Item', '/vacancy_alerts/', 'not found']))
      return t('errors.vacancyAlertNotFound');

    if (messageMatchesCondition(['applicant: Deze waarde wordt al gebruikt']))
      return t('errors.vacancyDuplicateApplication');

    return message;
  };
  return (
    <Card extraClasses="c-card--error u-padding-small">
      <p data-cy="graphql-error" className="u-margin-none">
        <strong>Error:</strong> {getErrorMessage()}
      </p>
    </Card>
  );
};

const DisplayError = ({ error }) => {
  if (!error || !error.message) return null;
  if (
    error.networkError &&
    error.networkError.result &&
    error.networkError.result.errors &&
    error.networkError.result.errors.length
  ) {
    return error.networkError.result.errors.map((error, i) => (
      <ErrorMessage
        key={i}
        message={error.message.replace('GraphQL error: ', '')}
      />
    ));
  }
  if (error.graphQLErrors && error.graphQLErrors.length) {
    return error.graphQLErrors.map((error, i) => {
      if (error.debugMessage) {
        return <ErrorMessage key={i} message={error.debugMessage} />;
      }
      const messages = error.message.split('\n');

      return messages.map(message => (
        <ErrorMessage
          key={i}
          message={message.replace('GraphQL error: ', '')}
        />
      ));
    });
  }

  return (
    <ErrorMessage message={error.message.replace('GraphQL error: ', '')} />
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

DisplayError.defaultProps = {
  error: {},
};

DisplayError.propTypes = {
  error: PropTypes.object,
};

export default DisplayError;
